export const blockIconsAndroidSignalWifi4BarNew = (
	<span className='material-symbols-outlined'>signal_wifi_4_bar</span>
);
